import { NotifyHelper } from "../../../helpers/toast";
import { objKhoLeadDefine } from "../../action-types/crm-survey/IKhoLeadActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const khoLeadActions = {
    ...generateActions(objKhoLeadDefine, "KHO_LEAD"),
    ...generateActionForKey(objKhoLeadDefine, "KHO_LEAD",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objKhoLeadDefine, "KHO_LEAD",
        "LOAD_THONGKE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objKhoLeadDefine, "KHO_LEAD",
        "LOAD_ROUNDROBIN_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objKhoLeadDefine, "KHO_LEAD",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Đã xóa Lead")),
    ...generateActionForKey(objKhoLeadDefine, "KHO_LEAD",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m)),
};
